import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/industries/IndustriesClient.tsx");
